module.exports = __webpack_public_path__ + "img/file-slides-fill.23f1abba.svg";